export default __webpack_public_path__ + "static/media/139.90e2091b.png";